module.exports = __webpack_public_path__ + "media/images/icons/loop-circular-60d93b9ba1f652107d4c1675c67f439d.svg";